module.exports = __webpack_public_path__ + "static/media/46_tn.7313a8b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/46_tn.jpg
// module id = 682
// module chunks = 0